import _path from "ramda/src/path";
import _prop from "ramda/src/prop";
import _tap from "ramda/src/tap";
import _lensProp from "ramda/src/lensProp";
import _over from "ramda/src/over";
import _when from "ramda/src/when";
import _assocPath from "ramda/src/assocPath";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _curry from "ramda/src/curry";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _asyncGeneratorDelegate from "@babel/runtime/helpers/asyncGeneratorDelegate";
var _excluded = ["connection", "cursor"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import { throwFirstError } from "../../../browser/graphql";
import { assertValidConnection, connectionEndCursor, connectionNodes, findFirstConnection } from "./lib";
export var ConnectionIterator = _curry(function () {
  var _ConnectionIterator = _wrapAsyncGenerator(_regeneratorRuntime.mark(function _callee(graphql, _ref) {
    var _ref$connection, getConnection, _ref$cursor, setCursor, opts, cursor, connection, hasNextPage;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref$connection = _ref.connection, getConnection = _ref$connection === void 0 ? findFirstConnection : _ref$connection, _ref$cursor = _ref.cursor, setCursor = _ref$cursor === void 0 ? _assocPath(['input', 'after']) : _ref$cursor, opts = _objectWithoutProperties(_ref, _excluded);
        case 1:
          _context.next = 3;
          return _awaitAsyncGenerator(Promise.resolve(opts).then(_when(function (_) {
            return cursor;
          }, _over(_lensProp('variables'), setCursor(cursor)))).then(graphql).then(_tap(throwFirstError)).then(_prop('data')).then(getConnection).then(_tap(assertValidConnection)));
        case 3:
          connection = _context.sent;
          return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(connectionNodes(connection)), _awaitAsyncGenerator), "t0", 5);
        case 5:
          hasNextPage = _path(['pageInfo', 'hasNextPage'], connection);
          if (hasNextPage) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return");
        case 8:
          cursor = connectionEndCursor(connection);
        case 9:
          if (cursor) {
            _context.next = 1;
            break;
          }
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  function ConnectionIterator(_x, _x2) {
    return _ConnectionIterator.apply(this, arguments);
  }
  return ConnectionIterator;
}());